import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_get_child_serial_numbers_by_serialNumberIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { serialNumberId: number }): 
  Promise<{ result: { Id?: number, ChildSerialNumbers?: { Id?: number, ChildSerialNumbers?: { Id?: number, ChildSerialNumbers?: { Id?: number }[] }[] }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberId)) {
      missingRequiredInParams.push('\'serialNumberId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_child_serial_numbers_by_serialNumberId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      serialNumberId: number    }) {
        if(isNil(inParams.serialNumberId)) {
          return true; 
        }
      return false;
    }
}
